import { Outlet } from 'react-router';

export default function AnnualStatementsPage() {
  return <Outlet />;
}
